/**
 * The base field of view through the player's own eyes.
 *
 * It writes one entry of [baseFovDegrees](../../../core/view/baseFovDegrees.ts), which
 * `viewPreference()` reads per tick on its way into every mode's step, so the drag widens the
 * running frame. The base only: a weapon's sights still narrow from whatever is chosen here, which
 * is what keeps a scope a scope at any lens. The bounds and the default are the camera contract's
 * own, stated in `sim/camera/viewPreference.ts`.
 */

import { setBaseFovDegrees } from '@/core/view/baseFovDegrees';
import { DEFAULT_FOV_DEGREES, MAX_FOV_DEGREES, MIN_FOV_DEGREES } from '@/sim/camera/viewPreference';
import { rangeApply } from '@/ui/settings/controls/rangeSlider';
import { SETTING_FOV_FIRST_HINT, SETTING_FOV_FIRST_LABEL } from '@/text/settingsText';
import type { SettingDefinition } from '@/ui/settings/settingContract';

export const FIRST_PERSON_FOV_DEGREES: SettingDefinition = {
  id: 'firstPersonFovDegrees',
  section: 'video',
  label: SETTING_FOV_FIRST_LABEL,
  hint: SETTING_FOV_FIRST_HINT,
  control: {
    kind: 'range',
    min: MIN_FOV_DEGREES,
    max: MAX_FOV_DEGREES,
    step: 1,
    format: (value: number): string => String(Math.round(value)),
  },
  defaultValue: DEFAULT_FOV_DEGREES,
  apply: rangeApply((value: number): void => {
    setBaseFovDegrees('firstPerson', value);
  }),
};
